// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import ShareLarge from '../_raw/ui/icon_share_large.svg';

export default withIconProps(ShareLarge);
